import { LitElement, html, svg } from 'lit';

export class IconEdit24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Blyant</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.963 2.037a3.557 3.557 0 0 0-5.055.034L2.731 16.249 1 23l6.751-1.732L21.93 7.091a3.557 3.557 0 0 0 .034-5.054v0Z"></path></svg>`; }
}
if (!customElements.get('f-icon-edit24', IconEdit24)) {
  customElements.define('f-icon-edit24', IconEdit24);
}